import React from 'react'

export default function VideoCrousel() {
    return (
        <div className='video-crousel'>
            <div className='row'>
                <div className='col-sm-3'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/xbqp1dT3WnA?si=N0-NuQl0NQkkql2s" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
                <div className='col-sm-3'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/HM5mU8u3nyg?si=UvcSAJr9622zRwId" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
                <div className='col-sm-3'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/lXkVs5guzgE?si=a-nnTtiM8G3G2uLH" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            </div>
        </div>
    )
}
